import { render } from "./ContractFeedback.vue?vue&type=template&id=67958a2c&scoped=true"
import script from "./ContractFeedback.vue?vue&type=script&lang=js"
export * from "./ContractFeedback.vue?vue&type=script&lang=js"

import "./ContractFeedback.vue?vue&type=style&index=0&id=67958a2c&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67958a2c"]])

export default __exports__